module.exports = __webpack_public_path__ + "static/London-Modular-ee6fbc4197165dd9d3933af7c10bba29.jpg";